import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { confirmOrder } from "../../axios/api/OrderApi";
import { getDashboardData } from "../../axios/api/dashboardApi";
import {
  changePopUpStatus,
  setRequestStatus,
} from "../../redux/slices/popUpSlice";

const OrderModal = ({ onClose, rowData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const handleClick = async (orderId) => {
    const responseData = await confirmOrder(orderId);
    if (responseData) {
      getDashboardData();
      dispatch(changePopUpStatus(true));
      dispatch(setRequestStatus(responseData));
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      //   onClick={onClose}
    >
      <div
        className="bg-white lg:rounded-t-xl lg:rounded-xl px-5 py-5 relative w-full h-full lg:w-[800px] lg:h-auto overflow-y-auto"
        onClick={handleModalClick}
      >
        {rowData.status !== "new" && (
          <button
            className="hidden lg:block absolute top-7 right-7 lg:top-9 lg:right-9 text-gray-200 hover:text-white z-50"
            onClick={onClose}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 1L1 11M1 1L11 11"
                stroke={rowData.status === "canceled" ? "#FFFFFF" : "#64748B"}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
        <div className="flex flex-col gap-5">
          {/* <section 1 */}
          <div
            className={`flex lg:items-center gap-2 p-2 ${
              rowData?.status === "canceled"
                ? "bg-red text-white"
                : "bg-white text-midnightBlue"
            }`}
          >
            {rowData?.status !== "inProgress" && (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 7.83333 0.625 5.88333 1.875 4.15C3.125 2.41667 4.78333 1.20833 6.85 0.525C7.33333 0.358333 7.77917 0.416667 8.1875 0.7C8.59583 0.983333 8.8 1.36667 8.8 1.85C8.8 2.18333 8.70417 2.4875 8.5125 2.7625C8.32083 3.0375 8.075 3.225 7.775 3.325C6.34167 3.775 5.1875 4.6125 4.3125 5.8375C3.4375 7.0625 3 8.45 3 10C3 11.95 3.67917 13.6042 5.0375 14.9625C6.39583 16.3208 8.05 17 10 17C10.8667 17 11.7042 16.85 12.5125 16.55C13.3208 16.25 14.0417 15.8167 14.675 15.25C14.925 15.0167 15.2292 14.9 15.5875 14.9C15.9458 14.9 16.25 15.0167 16.5 15.25C16.8833 15.6 17.0833 15.9958 17.1 16.4375C17.1167 16.8792 16.9333 17.2667 16.55 17.6C15.65 18.3833 14.6458 18.9792 13.5375 19.3875C12.4292 19.7958 11.25 20 10 20ZM17 10C17 8.46667 16.5583 7.0875 15.675 5.8625C14.7917 4.6375 13.6333 3.79167 12.2 3.325C11.9 3.225 11.6542 3.0375 11.4625 2.7625C11.2708 2.4875 11.175 2.18333 11.175 1.85C11.175 1.36667 11.3792 0.983333 11.7875 0.7C12.1958 0.416667 12.6417 0.358333 13.125 0.525C15.2083 1.225 16.875 2.44167 18.125 4.175C19.375 5.90833 20 7.85 20 10C20 10.3 19.9875 10.6042 19.9625 10.9125C19.9375 11.2208 19.8917 11.5583 19.825 11.925C19.7417 12.4083 19.4958 12.7542 19.0875 12.9625C18.6792 13.1708 18.2333 13.1833 17.75 13C17.4333 12.8833 17.1875 12.6708 17.0125 12.3625C16.8375 12.0542 16.7833 11.7333 16.85 11.4C16.9 11.1167 16.9375 10.8667 16.9625 10.65C16.9875 10.4333 17 10.2167 17 10Z"
                  fill={rowData.status === "canceled" ? "#FFFFFF" : "#EE5222"}
                />
              </svg>
            )}
            <span className="prose-t16_regular lg:prose-t18_medium">
              {rowData.status === "new"
                ? "Դուք ունեք նոր պատվեր"
                : rowData.status === "canceled"
                ? `Ձեր #${rowData?.orderId} համարի պատվերը չեղարկվել է`
                : rowData.status === "inProgress"
                ? "Պատվերի վիճակ"
                : rowData.status === "finished"
                ? `Ձեր #${rowData?.orderId} համարի պատվերը ավարտվել է`
                : ""}
            </span>
          </div>
          {/* section 1.7 */}
          {rowData.status === "inProgress" ? (
            <div className="flex gap-3 border-b">
              <span className="py-1.5 px-4 rounded-[20px] border border-primary bg-lightOrange prose-t12_regular text-primary">
                Ընթացքում
              </span>
              <span className="prose-t12_regular py-1.5 px-4 ">Ավարտված</span>
              <span className="prose-t12_regular py-1.5 px-4 ">Չեղարկված</span>
            </div>
          ) : (
            <></>
          )}
          {(rowData.status === "canceled" ||
            (rowData.status === "finished" && rowData.userComment)) && (
            <div className="flex flex-col items-start gap-2 border border-lightGray py-2.5 px-6 rounded-md">
              <span
                className={`prose-t12_regular ${
                  rowData.status === "canceled" ? "text-red" : "text-primary"
                }`}
              >
                {rowData.status === "canceled"
                  ? "Չեղարկման պատճառը"
                  : "Մեկնաբանություն"}
              </span>
              <span className="prose-t12_regular text-midnightBlue text-start">
                {rowData.status === "canceled"
                  ? rowData.cancelReason
                  : rowData.userComment}
              </span>
            </div>
          )}
          {/* section 2 */}
          <div className="flex flex-col gap-2 items-start py-6 px-6 border border-primary bg-lightOrange rounded-md">
            <span className="prose-t18_medium text-midnightBlue">
              #{rowData?.orderId}
            </span>
            <span className="prose-t14_regular text-midnightBlue text-start">
              Գրանցման ամսաթիվ: {rowData?.orderDate}
            </span>
          </div>
          {/* section 3 */}
          <span className="prose-t20_bold text-midnightBlue text-start">
            Պատվեր
          </span>
          {/* section 4 */}
          <div className="flex flex-col border border-lightGray rounded-md ">
            <div className="flex justify-between py-2.5 px-5 bg-veryLightGray px-6">
              <span className="prose-t16_bold text-midnightBlue">
                Ծառայություն
              </span>
              <span className="hidden lg:block prose-t16_bold text-midnightBlue ">
                Գին
              </span>
            </div>
            <div className="flex flex-col lg:flex-row justify-between py-4 px-5">
              <div className="flex gap-4">
                <img src="/assets/cleaning.png" alt="service" />
                <div className="flex flex-col justify-start items-start  lg:justify-center gap-1  ">
                  <span className="prose-t16_regular text-primary">
                    {rowData?.serviceName}
                  </span>
                  <p className="prose-t16_regular text-midnightBlue  text-start break-words ">
                    {rowData?.orderDetails}
                  </p>
                </div>
              </div>
              <div className="flex gap-2 pt-2">
                <span className="lg:hidden text-start   prose-t16_bold text-midnightBlue ">
                  Գին
                </span>
                <span className="text-start prose-t18_bold text-primary ">
                  {rowData.amount} {"\u058F"}
                </span>
              </div>
            </div>
          </div>
          {/* section 5 */}
          <div className="flex  py-4 px-6">
            <div className="flex flex-col items-start gap-6  ">
              <div className="flex flex-col items-start gap-3">
                {/* <span className="prose-t14_medium text-midnightBlue">
                  Դանիել Մկրտչյան
                </span> */}
                <div className="flex  items-start gap-3">
                  <span className="prose-t14_regular text-midnightBlue text-start">
                    Հասցե:
                  </span>
                  <span className="prose-t14_regular text-slateGray text-start">
                    {rowData.address}
                  </span>
                </div>
                <span className="flex gap-2 prose-t14_regular text-midnightBlue">
                  Հեռախոսահամար:
                  <span className="text-slateGray">{rowData.phoneNumber}</span>
                </span>
              </div>
            </div>
            {/* <div className="flex flex-col items-start gap-6 w-1/2 px-3">
              <span className="text-midnightBlue prose-t18_medium">
                Հավելյալ Նշումներ
              </span>
              <span className="prose-t14_regular text-slateGray text-start">
                Lorem ipsum dolor sit amet consectetur. Sit et pellentesque
                tincidunt faucibus ac in dignissim varius. Tincidunt purus sit
                dui proin aliquet tincidunt massa nec. Lacus tempor egestas
                faucibus dis sit faucibus. Dictumst posuere felis aliquam
                sagittis.
              </span>
            </div> */}
          </div>
        </div>

        {rowData.status === "canceled" ||
        rowData.status === "inProgress" ||
        rowData.status === "finished" ? (
          <div>
            <button
              className="prose-t16_bold border border-primary text-primary hover:bg-primary hover:text-white py-3 px-6 rounded-xl"
              onClick={onClose}
            >
              Փակել
            </button>
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row items-center gap-2.5">
            <div className="flex items-center gap-2.5 py-3 px-5">
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.2509 19.8062C23.3347 18.8832 21.1158 17.5361 20.0393 16.9933C18.6373 16.2871 18.5219 16.2294 17.42 17.0481C16.6849 17.5944 16.1963 18.0824 15.3361 17.899C14.4759 17.7155 12.6066 16.6811 10.9698 15.0497C9.33303 13.4182 8.23858 11.4948 8.05454 10.6376C7.8705 9.78029 8.36666 9.29743 8.90783 8.56073C9.67054 7.52231 9.61285 7.34924 8.96091 5.94738C8.45263 4.85704 7.06625 2.65906 6.13969 1.74756C5.14851 0.768566 5.14851 0.941635 4.50984 1.20701C3.98989 1.42576 3.49106 1.69167 3.01961 2.0014C2.09651 2.61464 1.58419 3.12404 1.22591 3.88959C0.867635 4.65513 0.706669 6.44986 2.55691 9.81087C4.40714 13.1719 5.70525 14.8905 8.39205 17.5696C11.0788 20.2487 13.1449 21.6892 16.1651 23.383C19.9014 25.4754 21.3345 25.0675 22.1024 24.7098C22.8703 24.3522 23.382 23.8445 23.9965 22.9215C24.307 22.4508 24.5735 21.9526 24.7926 21.4331C25.0586 20.7967 25.2317 20.7967 24.2509 19.8062Z"
                  stroke="#181F46"
                  strokeWidth="2"
                  strokeMiterlimit="10"
                />
              </svg>
              <a
                href="tel:+37433633611"
                className="prose-t16_bold text-midnightBlue cursor-pointer"
                onClick={(e) => e.stopPropagation()}
              >
                Կապ հաստատել մեզ հետ
              </a>
            </div>
            <button
              className="bg-primary hover:brightness-90 text-white prose-t16_bold py-3 px-[50px] rounded-xl"
              onClick={() => handleClick(rowData.orderId)}
            >
              Ընդունել Պատվերը
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderModal;
